import { HatConstants } from "./constants/hat-constants";
import { EventType } from "./constants/event-type-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { TimerCountdown } from "./helpers/timer-countdown";
import { MarketingClientAttributesConstants } from "./constants/marketing-client-attributes-constants";
import { UtilizationConstants } from "./constants/marketing-client-utilization-constants";
export class Hat {
    constructor(isMobile, utilization) {
        this.isMobile = isMobile;
        this.utilization = utilization;
        this.prevAnimationAPosY = window.scrollY;
        this.prevPosY = window.scrollY;
        this.marginOfError = 9;
    }
    init() {
        var _a, _b, _c, _d, _e;
        const hat = DOMHelper.querySelector(HatConstants.hatSelector), hatWrapper = DOMHelper.querySelector(HatConstants.harWrapperSelector), scrollDown = (_a = hat === null || hat === void 0 ? void 0 : hat.getAttribute(HatConstants.dataScrollDown)) !== null && _a !== void 0 ? _a : "0", scrollUp = (_b = hat === null || hat === void 0 ? void 0 : hat.getAttribute(HatConstants.dataScrollUp)) !== null && _b !== void 0 ? _b : "0";
        this.closeButton = DOMHelper.querySelector(HatConstants.closeButton);
        this.expandButton = DOMHelper.querySelector(HatConstants.expandButton);
        this.expandSection = DOMHelper.querySelector(HatConstants.expandSection);
        this.expandButtonMobile = DOMHelper.querySelector(HatConstants.expandButtonMobile);
        this.ctaButtonAgree = DOMHelper.querySelector(HatConstants.ctaButtonAgree);
        this.ctaButtonDescription = DOMHelper.querySelector(HatConstants.ctaButtonDescription);
        this.parentLinkElement = (_c = this.ctaButtonDescription) === null || _c === void 0 ? void 0 : _c.closest(`[${MarketingClientAttributesConstants.placeholderId}]`);
        this.condition = ((_d = this.ctaButtonAgree) === null || _d === void 0 ? void 0 : _d.getAttribute(UtilizationConstants.dataUtilize));
        const hatTimer = DOMHelper.querySelector(HatConstants.timerDateSelector);
        this.scrollHandler(hatWrapper);
        this.scrollAnimation(hatWrapper, scrollDown, scrollUp);
        this.bindEvents();
        this.initializeTimer((_e = hatTimer === null || hatTimer === void 0 ? void 0 : hatTimer.dataset) === null || _e === void 0 ? void 0 : _e.timerHat, hatTimer === null || hatTimer === void 0 ? void 0 : hatTimer.dataset);
    }
    bindEvents() {
        var _a, _b, _c, _d;
        (_a = this.closeButton) === null || _a === void 0 ? void 0 : _a.addEventListener(EventType.CLICK, () => this.hideCtaSection());
        (_b = this.expandButton) === null || _b === void 0 ? void 0 : _b.addEventListener(EventType.CLICK, () => this.expandCtaSection());
        (_c = this.expandButtonMobile) === null || _c === void 0 ? void 0 : _c.addEventListener(EventType.CLICK, () => this.expandCtaSection());
        (_d = this.ctaButtonDescription) === null || _d === void 0 ? void 0 : _d.addEventListener(EventType.CLICK, () => this.utilizationButtonDescription());
    }
    utilizationButtonDescription() {
        var _a;
        if (this.parentLinkElement)
            this.utilization.sendBigDataEvent(this.parentLinkElement, (_a = this.condition) !== null && _a !== void 0 ? _a : undefined, HatConstants.clickIdDescription);
    }
    expandCtaSection() {
        var _a, _b, _c;
        (_a = this.expandSection) === null || _a === void 0 ? void 0 : _a.classList.add(HatConstants.ctaVisible);
        this.expandAnimation();
        (_b = this.ctaButtonAgree) === null || _b === void 0 ? void 0 : _b.removeAttribute('tabindex');
        (_c = this.ctaButtonDescription) === null || _c === void 0 ? void 0 : _c.removeAttribute('tabindex');
    }
    hideCtaSection() {
        var _a, _b, _c;
        (_a = this.expandSection) === null || _a === void 0 ? void 0 : _a.classList.remove(HatConstants.ctaVisible);
        this.expandAnimation();
        (_b = this.ctaButtonAgree) === null || _b === void 0 ? void 0 : _b.setAttribute('tabindex', '-1');
        (_c = this.ctaButtonDescription) === null || _c === void 0 ? void 0 : _c.setAttribute('tabindex', '-1');
    }
    scrollHandler(hatWrapper) {
        window.addEventListener(EventType.SCROLL, () => {
            if (window.scrollY > 130) {
                if (!!(hatWrapper === null || hatWrapper === void 0 ? void 0 : hatWrapper.parentElement)) {
                    hatWrapper.parentElement.classList.add(HatConstants.hiddenHat);
                }
            }
            else if (window.scrollY === 0) {
                if (!!(hatWrapper === null || hatWrapper === void 0 ? void 0 : hatWrapper.parentElement)) {
                    hatWrapper.parentElement.classList.remove(HatConstants.hiddenHat);
                }
            }
        }, { passive: true });
    }
    scrollAnimation(hatWrapper, scrollDown, scrollUp) {
        if (!this.isMobile)
            return;
        window.addEventListener(EventType.SCROLL, () => {
            const currentPosition = this.prevPosY >= window.scrollY - this.marginOfError ? HatConstants.top : HatConstants.bottom;
            if (currentPosition === HatConstants.bottom && this.prevPosY > Number(scrollDown)) {
                hatWrapper === null || hatWrapper === void 0 ? void 0 : hatWrapper.classList.add(HatConstants.scrollDownClass);
                this.prevAnimationAPosY = window.scrollY;
            }
            else if (currentPosition === HatConstants.top && this.prevPosY < this.prevAnimationAPosY - Number(scrollUp)) {
                hatWrapper === null || hatWrapper === void 0 ? void 0 : hatWrapper.classList.remove(HatConstants.scrollDownClass);
            }
            this.prevPosY = window.scrollY;
        }, { passive: true });
    }
    expandAnimation() {
        var _a;
        (_a = this.expandSection) === null || _a === void 0 ? void 0 : _a.classList.add(HatConstants.ctaAnimation);
        setTimeout(() => {
            var _a;
            (_a = this.expandSection) === null || _a === void 0 ? void 0 : _a.classList.remove(HatConstants.ctaAnimation);
        }, 500);
    }
    initializeTimer(dateEnd, dataset) {
        var _a;
        if (!dateEnd)
            return;
        this.timerCountdown = new TimerCountdown(dateEnd, HatConstants.timerSelector, dataset);
        (_a = this.timerCountdown) === null || _a === void 0 ? void 0 : _a.init();
    }
}
